export default __webpack_public_path__ + "static/14-e0c9ca01b3b748ddcbdef0618afa09d8.webp";